
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locationID]",
      function () {
        return require("private-next-pages/[locationID]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locationID]"])
      });
    }
  